import { type TypographyCommon, type Variant } from './types'
import { BaseTypography } from './BaseTypography'

type Props = TypographyCommon<{
  /**
   * Set your color
   * @default 'primary'
   */
  variant?: Variant<'primary' | 'secondary' | 'tertiary' | 'goGreen'>
}>

/**
 * Demos:
 * - [Subtitle1](https://design-system.accept.cl1.intra.dhlparcel.io/?path=/story/primitives-typography--subtitle-1)
 *
 */

export const Subtitle1 = ({ children, variant = 'primary', ...rest }: Props) => (
  <BaseTypography variant="subtitle1" color={variant} {...rest}>
    {children}
  </BaseTypography>
)
